import {
  FEATURE_FLAGS_NAMES,
  PERMISSION_ACTION,
  PERMISSION_DOMAIN
} from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import intersection from 'lodash/intersection';
import { useMemo } from 'react';

const useDevCoachingModule = ({
  permissions = [],
  customizationOptions,
  userPermissionDomainIds,
  removePermissionsDomainIds,
  addPermissionDomainId,
  userConfig
}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const isDevCoachingFFEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isDevCoachingEnabled
  });

  const devCoachingPermissionIds = useMemo(() => {
    const allPermissions = permissions.filter(
      ({ name }) => name === PERMISSION_DOMAIN.DEV_COACHING
    );

    const editPermission = allPermissions.find(
      ({ name, action }) =>
        name === PERMISSION_DOMAIN.DEV_COACHING &&
        action === PERMISSION_ACTION.EDIT
    );

    const viewPermission = allPermissions.find(
      ({ name, action }) =>
        name === PERMISSION_DOMAIN.DEV_COACHING &&
        action === PERMISSION_ACTION.VIEW
    );

    return {
      all: allPermissions.map(({ id }) => id),
      edit: editPermission?.id,
      view: viewPermission?.id
    };
  }, [permissions]);

  const devCoachingEnabledForNonAdmins =
    intersection(userPermissionDomainIds, devCoachingPermissionIds.all).length >
    0;

  const showDevCoachingToggle =
    customizationOptions.showPersonalInformation && isDevCoachingFFEnabled;

  const toggleDevCoachingPermissions = () => {
    if (devCoachingEnabledForNonAdmins) {
      removePermissionsDomainIds(devCoachingPermissionIds.all);
    }
    addPermissionDomainId(devCoachingPermissionIds.view);
  };

  const devCoachingEnabled =
    isDevCoachingFFEnabled &&
    (devCoachingEnabledForNonAdmins ||
      userConfig.isAdmin ||
      userConfig.isSuperUser);

  return {
    toggleDevCoachingPermissions,
    showDevCoachingToggle,
    devCoachingEnabled,
    isAdmin: userConfig.isAdmin
  };
};

export default useDevCoachingModule;
